import { PopupSynchronizeComponent } from './popup-synchronize.component';

export const PopupSynchronizeModule = angular
  .module('sfMobile.components.popup-synchronize', [])
  .component('sfPopupSynchronize', PopupSynchronizeComponent).name;
